import { useMutation } from '@tanstack/react-query'
import Cookies from 'js-cookie'
import { putData } from 'src/api/api-utilities'
import { useIsMobileQuery } from 'src/hooks/useMediaQuery'
import { getRedirectUrl, isValidRedirectUrl } from 'src/utils/helpers/RedirectHelpers'

const updatePassword = async (params) => {
  const url = params.reset_password_token ? '/users/password' : '/users/password/reset'
  const response = await putData(url, { user: { ...params } })
  return response
}

const handlePostPasswordUpdateRedirect = (redirectUrl, isResetToken, isMobileSize) => {
  const finalRedirectUrl = redirectUrl && isValidRedirectUrl(redirectUrl) ? redirectUrl : '/programs'

  if (isResetToken && isMobileSize) {
    const forwardToMobile = confirm('Would you like to continue on the mobile application?')
    if (forwardToMobile) {
      window.location.href = 'my-evanta-app://'
      // If the mobile app does not open within 2 seconds, redirect back to /programs so the user isn't stuck on the modal.
      setTimeout(() => {
        window.location.href = finalRedirectUrl
      }, 2000)
    } else {
      window.location.href = finalRedirectUrl
    }
  } else {
    window.location.href = finalRedirectUrl
  }
}

const useUpdatePassword = () => {
  const isMobileSize = useIsMobileQuery()
  const redirectUrl = getRedirectUrl()

  const { mutateAsync, mutate } = useMutation({
    mutationFn: updatePassword,
    onSuccess: (data, params) => {
      if (data.status === 200) {
        Cookies.set('token', data.data.auth_token)
        handlePostPasswordUpdateRedirect(redirectUrl, params.reset_password_token, isMobileSize)
      }
    }
  })

  return { mutateAsync, mutate }
}

export default useUpdatePassword
